import { NavLink, Link } from "react-router-dom";
import { IoPersonCircle, IoMenu } from "react-icons/io5";
import { FaArrowLeft } from "react-icons/fa";
import { IoMdFootball } from "react-icons/io";
import { useContext, useState, useEffect } from "react";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";

function Navbar() {
  const [visible, setVisible] = useState(false);
  const [is_dropdown_open, set_dropdown] = useState(false);

  const {
    token,
    setUser,
    setToken,
    user,
    backendURL,
    navigate,
    setPending,
    setShowAlert,
    setAlertMessage,
  } = useContext(PitchContext);

  const [dropdownTimeout, setDropdownTimeout] = useState(null);

  // Add useEffect to handle body overflow
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [visible]);

  const sendEmail = () => {
    setPending(true);
    axios
      .post(backendURL + `user/send-verify-link/${token}`, {
        userID: user._id,
        email: user.email,
        userName: user.fullname,
      })
      .then((response) => {
        setPending(false);
        setShowAlert(true);
        setAlertMessage("Doğrulama bağlantısı e-postanıza gönderildi");
      })
      .catch((err) => {
        setPending(false);
        setShowAlert(true);
        setAlertMessage("Ağ hatası");
      });
  };

  const handleMouseEnter = () => {
    if (dropdownTimeout) {
      clearTimeout(dropdownTimeout);
      setDropdownTimeout(null);
    }
    set_dropdown(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      set_dropdown(false);
    }, 200);
    setDropdownTimeout(timeout);
  };

  const logout = () => {
    setVisible(false);
    navigate("/giris-yap");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("bookinID");
    localStorage.removeItem("isPaid");
    setToken("");
    setUser({});
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 ">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link
            className="flex items-center gap-2 group transition-all duration-300"
            to="/"
          >
            <h1 className="text-2xl font-extrabold tracking-tight">
              h
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                a
              </span>
              l
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                i
              </span>
              s
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                a
              </span>
              h
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                a
              </span>
              b
              <span className="text-[#4d9041] group-hover:text-[#62a556]">
                u
              </span>
              l
            </h1>
            <img src="/reduced-logo.webp" alt="" className="w-15 sm:w-20" />
          </Link>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex items-center gap-10">
            {[
              { to: "/", label: "Anasayfa" },
              { to: "/sahalar", label: "Sahalar" },
              { to: "/takim-arkadasi-bul", label: "Oyuncu Bul" },
              { to: "/rakip-bul", label: "Rakip Bul" },
              { to: "/hakkimizda", label: "Hakkımızda" },
              { to: "/iletisim", label: "İletişim" },
            ].map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `relative text-base font-medium transition-all duration-300 px-2 py-1 rounded-md ${
                      isActive
                        ? "text-[#6ca87e] bg-[#6ca87e]/10"
                        : "text-gray-700 hover:text-[#6ca87e] hover:bg-gray-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Right Section */}
          <div className="flex items-center gap-1">
            {/* Profile Dropdown */}
            <div
              className="hidden sm:block sm:group sm:relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                to={token ? "/profil" : "/giris-yap"}
                className="flex items-center"
              >
                {token ? (
                  <img
                    className="w-9 h-9 rounded-full object-cover ring-2 ring-[#6ca87e]/20 hover:ring-[#6ca87e] transition-all duration-300"
                    src={user.profilePicture}
                    alt="Profil"
                  />
                ) : (
                  <IoPersonCircle className="text-3xl text-gray-600 hover:text-[#6ca87e] transition-colors duration-300" />
                )}
              </Link>
              {token && is_dropdown_open && (
                <div className="absolute right-0 top-full mt-3 z-20 animate-dropdown">
                  <div className="bg-white shadow-xl rounded-lg p-4 w-72 border border-gray-100">
                    <div className="space-y-3">
                      <Link
                        to="/profil"
                        className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-50 transition-colors duration-200"
                      >
                        <span className="text-[#6ca87e]">✉️</span>
                        <span className="text-sm text-gray-800 font-medium truncate">
                          {user.email}
                        </span>
                      </Link>
                      <Link
                        to="/profil"
                        className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-50 transition-colors duration-200"
                      >
                        <span className="text-[#6ca87e]">👤</span>
                        <span className="text-sm text-gray-700">Profilim</span>
                      </Link>
                      {user.verified ? null : (
                        <button
                          onClick={sendEmail}
                          className="flex items-center gap-3 p-2 w-full text-left rounded-md hover:bg-gray-50 transition-colors duration-200"
                        >
                          <span className="text-[#6ca87e]">✉️</span>
                          <span className="text-sm text-gray-700 cursor-pointer">
                            Doğrulama Bağlantısı Al
                          </span>
                        </button>
                      )}
                      <button
                        onClick={logout}
                        className="flex items-center justify-center gap-2 w-full p-2 bg-red-50 text-red-600 hover:bg-red-100 rounded-md transition-colors duration-200 cursor-pointer"
                      >
                        <span className="text-sm font-medium">Çıkış Yap</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setVisible((prev) => !prev)}
              className="lg:hidden p-1 rounded-md hover:bg-gray-100 transition-colors duration-200"
            >
              <IoMenu className="text-3xl text-gray-600 hover:text-[#6ca87e]" />
            </button>

            {/* Mobile Menu */}
            <div
              className={`fixed inset-0 bg-white z-40 transform transition-transform duration-300 ease-in-out ${
                visible ? "translate-x-0" : "translate-x-full"
              }`}
            >
              <div className="flex flex-col h-full px-4">
                <div className="flex-1 space-y-4 py-6">
                  <button
                    onClick={() => setVisible(false)}
                    className="flex items-center justify-between p-3 w-full rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <FaArrowLeft className="text-xl text-[#6ca87e]" />
                      <span className="text-lg font-medium text-gray-700">
                        Geri
                      </span>
                    </div>
                    {token && (
                      <img
                        className="w-9 h-9 rounded-full object-cover ring-2 ring-[#6ca87e]/20 hover:ring-[#6ca87e] transition-all duration-300"
                        src={user.profilePicture}
                        alt="Profil"
                      />
                    )}
                  </button>
                  <div className="border-t border-gray-200" />
                  {[
                    { to: "/", label: "Anasayfa" },
                    { to: "/sahalar", label: "Sahalar" },
                    { to: "/takim-arkadasi-bul", label: "Oyuncu Bul" },
                    { to: "/rakip-bul", label: "Rakip Bul" },
                    {
                      to: `${token ? "/profil" : "/giris-yap"}`,
                      label: "Profil",
                    },
                    { to: "/hakkimizda", label: "Hakkımızda" },
                    { to: "/iletisim", label: "İletişim" },
                  ].map((item) => (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      onClick={() => setVisible(false)}
                      className={({ isActive }) =>
                        `block p-3 rounded-lg text-lg font-medium transition-colors ${
                          isActive
                            ? "text-[#6ca87e] bg-[#6ca87e]/10"
                            : "text-gray-700 hover:text-[#6ca87e] hover:bg-gray-100"
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  ))}
                  {token && !user.verified && (
                    <button
                      onClick={sendEmail}
                      className="flex items-center gap-3 p-2 w-full text-left rounded-md hover:bg-gray-50 transition-colors duration-200"
                    >
                      <span className="text-[#6ca87e]">✉️</span>
                      <span className="text-sm text-gray-700 cursor-pointer">
                        Doğrulama Bağlantısı Al
                      </span>
                    </button>
                  )}
                  {token && (
                    <button
                      onClick={logout}
                      className="flex items-center justify-center gap-2 w-full p-2 bg-red-50 text-red-600 hover:bg-red-100 rounded-md transition-colors duration-200 cursor-pointer"
                    >
                      <span className="text-sm font-medium">Çıkış Yap</span>
                    </button>
                  )}
                  {!token && (
                    <Link
                      to={"/giris-yap"}
                      onClick={() => setVisible((prev) => !prev)}
                      className="flex items-center justify-center gap-2 w-full p-2 bg-green-50 text-green-600 hover:bg-green-100 rounded-md transition-colors duration-200 cursor-pointer"
                    >
                      <span className="text-sm font-medium">Giriş Yap</span>
                    </Link>
                  )}
                </div>

                {/* Mobile Logo */}
                <div className="text-center border-t border-gray-200 py-6">
                  <Link
                    to="/"
                    className="flex items-center justify-center gap-2"
                    onClick={() => setVisible(false)}
                  >
                    <h1 className="text-2xl font-extrabold tracking-tight">
                      H
                      <span className="text-[#6ca87e] group-hover:text-[#8cc49e]">
                        A
                      </span>
                      L
                      <span className="text-[#6ca87e] group-hover:text-[#8cc49e]">
                        I
                      </span>
                      S
                      <span className="text-[#6ca87e] group-hover:text-[#8cc49e]">
                        A
                      </span>
                      H
                      <span className="text-[#6ca87e] group-hover:text-[#8cc49e]">
                        A
                      </span>
                      B
                      <span className="text-[#6ca87e] group-hover:text-[#8cc49e]">
                        U
                      </span>
                      L
                    </h1>
                    <IoMdFootball className="text-3xl text-[#6ca87e] group-hover:rotate-12 transition-transform duration-300" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Global CSS for Animation */}
      <style>
        {`
          @keyframes dropdown {
            from {
              opacity: 0;
              transform: translateY(-8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-dropdown {
            animation: dropdown 0.2s ease-out;
          }
        `}
      </style>
    </nav>
  );
}

export default Navbar;
